module.exports = __webpack_public_path__ + "img/a070681.svg";